/* ==========================================================================
   En-tête Cabinet — teinte et présence au défilement

   Ce fichier est chargé en `defer` par la section cv-entete : il s'exécute donc
   une fois le document analysé, quand le héros existe. Une version en ligne
   juste après l'en-tête ne le trouvait pas : à cet instant il n'est pas écrit.

   CE QUI DÉFILE N'EST PAS LA FENÊTRE. Au-dessus de 990 px, Horizon pose
   `height: 100dvh; overflow: hidden` sur `html` et `body` et fait défiler
   `.page-wrapper`. `window.scrollY` ne bouge donc jamais, et l'événement
   `scroll` d'un élément ne remonte pas jusqu'à `window`. On lit donc les deux
   positions possibles et on écoute les deux émetteurs.

   DEUX ÉTATS, DEUX RÔLES.

   `data-epingle` décide de la TEINTE : blanc transparent tant que le héros est
   derrière, papier et encre ensuite. Un IntersectionObserver s'en charge, car
   il raisonne en zone visible et se moque de savoir quel élément défile. Le
   rootMargin négatif vaut la hauteur de l'en-tête : la bascule tombe à la
   seconde où le bas du héros passe dessous.

   `data-cache` décide de la PRÉSENCE : l'en-tête s'efface quand on descend et
   revient quand on remonte. Un en-tête qui réapparaît pendant qu'on descend
   donne un mouvement à contresens du geste, et c'est ce qui se remarque ; ici
   le mouvement suit le geste. En haut de page il est toujours montré. Le seuil
   de 4 px évite qu'un tremblement de trackpad fasse clignoter l'en-tête.
   ========================================================================== */

(function () {
  var entete = document.getElementById('cv-entete');
  if (!entete) return;

  var wrapper = document.querySelector('.page-wrapper');
  var annonce = document.querySelector('.cv-annonce');

  /* Les sections qui se calent sous l'en-tête lisent ces deux variables. La
     hauteur de l'annonce sert aussi au `top` négatif du groupe d'en-tête :
     c'est ce qui laisse la barre d'annonce partir alors que l'en-tête reste. */
  function mesure() {
    var racine = document.documentElement.style;
    racine.setProperty('--cv-entete-mesure', entete.offsetHeight + 'px');
    racine.setProperty('--cv-annonce-mesure', (annonce ? annonce.offsetHeight : 0) + 'px');
  }
  mesure();
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(mesure);
    ro.observe(entete);
    if (annonce) ro.observe(annonce);
  }

  /* ---- Présence : on s'efface en descendant, on revient en remontant ---- */

  function position() {
    return Math.max(window.scrollY || 0, wrapper ? wrapper.scrollTop : 0);
  }

  var precedente = position();
  var enAttente = false;

  function surDefilement() {
    if (enAttente) return;
    enAttente = true;
    window.requestAnimationFrame(function () {
      var y = position();
      var ecart = y - precedente;

      if (y <= 8) {
        entete.dataset.cache = 'false';
      } else if (ecart > 4) {
        entete.dataset.cache = 'true';
      } else if (ecart < -4) {
        entete.dataset.cache = 'false';
      }

      precedente = y;
      enAttente = false;
    });
  }

  entete.dataset.cache = 'false';
  window.addEventListener('scroll', surDefilement, { passive: true });
  if (wrapper) wrapper.addEventListener('scroll', surDefilement, { passive: true });

  /* Le tiroir de menu bloque le défilement : on ne veut pas que l'en-tête
     s'efface pendant qu'il est ouvert. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') entete.dataset.cache = 'false';
  });

  /* ---- Teinte : transparent tant que le héros est derrière ---- */

  if (entete.dataset.transparent !== 'true') return;

  var heros = document.querySelector('[data-cv-heros]');

  function poser(epingle) {
    var v = epingle ? 'true' : 'false';
    if (entete.dataset.epingle !== v) entete.dataset.epingle = v;
  }

  if (heros && 'IntersectionObserver' in window) {
    var obs = null;

    var creer = function () {
      if (obs) obs.disconnect();
      obs = new IntersectionObserver(
        function (entrees) { poser(!entrees[0].isIntersecting); },
        { rootMargin: '-' + Math.round(entete.offsetHeight) + 'px 0px 0px 0px', threshold: 0 }
      );
      obs.observe(heros);
    };

    creer();
    window.addEventListener('resize', creer);
    return;
  }

  /* Repli sans IntersectionObserver : seuil calculé à la main. */
  function seuil() {
    return heros ? heros.offsetHeight - entete.offsetHeight : 400;
  }

  var s = seuil();

  function surDefilementTeinte() {
    poser(position() > s);
  }

  window.addEventListener('scroll', surDefilementTeinte, { passive: true });
  if (wrapper) wrapper.addEventListener('scroll', surDefilementTeinte, { passive: true });
  window.addEventListener('resize', function () { s = seuil(); surDefilementTeinte(); });
  surDefilementTeinte();
})();
